import React, { useMemo } from 'react';
import SectionTabs from './SectionTabs';
import SchoolRegistrationsSection from './registration/SchoolRegistrationsSection';
import ParticipantRegistrationsSection from './registration/ParticipantRegistrationsSection';
import EntryRegistrationsSection from './registration/EntryRegistrationsSection';
import SchoolLookupSection from './registration/SchoolLookupSection';

// Registration pages, in tab order. Also drives the breadcrumb label and the
// sidebar search (see AdminDashboard.js).
export const REG_SUBSECTIONS = [
  { id: 'schools', label: 'School Registrations', description: 'Schools registered for this event, payment status, confirmation' },
  { id: 'participants', label: 'Participant Registrations', description: 'Individual dancer registrations per school' },
  { id: 'entries', label: 'Entry Registrations', description: 'Dance entries submitted per school, categories, performance order' },
  { id: 'lookup', label: 'School Payments', description: 'View all fees and payment status by school' },
];

// Router for the "Registration" event section — each tab is its own
// component under registration/. canBoth: has both Account Admin and Event
// Admin — School Payments (the fee/payment budget page) and editing School
// Registrations both require it, since they touch money and shouldn't be
// reachable by either privilege alone (the backend checks too). Without it
// School Payments isn't one of the tabs, so if it arrives anyway (sidebar
// search, Quick Links, or a saved nav state from before a privilege was
// revoked) SectionTabs sends the user to a tab they can open instead.
export default function EventRegistrationSection({ event, activeSection, setActiveSection, canBoth }) {
  const tabs = useMemo(() => REG_SUBSECTIONS.filter(s => s.id !== 'lookup' || canBoth), [canBoth]);
  return (
    <SectionTabs sectionKey="registration" tabs={tabs} activeSection={activeSection} setActiveSection={setActiveSection}>
      {(id) => (
        <>
          {id === 'schools' && <SchoolRegistrationsSection event={event} canEdit={canBoth} />}
          {id === 'participants' && <ParticipantRegistrationsSection />}
          {id === 'entries' && <EntryRegistrationsSection />}
          {id === 'lookup' && <SchoolLookupSection event={event} />}
        </>
      )}
    </SectionTabs>
  );
}
